export interface Review {
  name: string;
  message: string;
  date?: string;
}

export const reviews: Review[] = [
  {
    name: "Ingrid",
    message:
      "Lucy is vandaag weer thuisgekomen na een  fantastische vakantie bij Nicoline. ☺️ Heel veel gewandeld, gezwommen en met de bal gespeeld! Nu ligt ze moe maar tevreden in haar mand. Ik heb Lucy met een gerust hart achtergelaten voor de vakantie! ❤️",
    date: "2025-07-25",
  },
  {
    name: "Marjolein",
    message:
      "Wat een fijne plek om je hondje naar toe te brengen! Ik vind het altijd wel spannend om mijn hond ergens achter te laten om te logeren. Dus dat doe ik dan ook alleen bij hoge uitzondering. Maar bij Nicoline voelde het meteen goed. Zij weet ook écht hoe om te gaan met honden, en al helemaal met Flatcoats😍. Ik zag dat Jesper volkomen relaxed was bij Nicoline thuis en in de tuin. En toen ik hem dan daadwerkelijk achter ging laten voor een proefnachtje heb ik zowaar op de terugweg geen moment zorgen of iets gevoeld. En Jesper heeft het prima naar zijn zin gehad. Hoe heerlijk is dat! Dus als we van de winter een week gaan skiën en hij uit logeren gaat, dan weet ik dat hij een fantastische tijd gaat hebben. En ik dus ook😃. Ik heb mijn ideale plekje gevonden 🥳.",
    date: "2025-06-25",
  },
  {
    name: "Judith",
    message:
      "Onze Jet heeft genoten! Wat een enorme hoeveelheid liefde voor iedere hond in dit huis! Nicoline is echt een topper!",
    date: "2025-06-24",
  },
  {
    name: "Eline",
    message: `Soof heeft een weekje bij Nicolien gelogeerd. Regelmatig foto's en filmpjes voorbij zien komen van " the real flatlife". Zwemmen, rennen en lekker dollen met andere honden. Daarna chillen in de tuin. Ik zag een blij relaxed hondje toen ik haar kwam halen, en laat Soof een volgende keer met een gerust ♥️ achter. Dank je Nicoline voor de goede zorgen, 🐾`,
    date: "2025-06-13",
  },
  {
    name: "Karin",
    message: `Jony heeft 8 nachten gelogeerd en wat heeft hij het goed gehad 🥰. Nicoline is een echte dierenvriend, weet heel goed wat een hond nodig heeft. Lekkere wandelingen, heerlijk zwemmen en lekker razen in de polder. Zoek je een oppas dan zou ik zeker aanraden om eens kennis te maken. Mocht ik weer een oppas nodig hebben en het niet in mijn eigen kringen op kan lossen zal ik zeker Nicoline weer bellen. Jony zal zeker weten weer heel blij zijn als we bij haar de straat in komen rijden, hij onthoudt dit fijne plekje zeker 🐾🐾 Tijdens onze vakantie konden we de avonturen die hij beleefde volgen op haar site. Dit is zo fijn! En de verhalen, je wordt er blij van 🥰`,
    date: "2025-06-03",
  },
  {
    name: "Miranda",
    message: `Afgelopen weekend Skye voor het eerst bij Nicoline in de opvang gehad. Wat een liefdevolle, enthousiaste vrouw, met veel passie en kennis. Skye heeft het erg goed gehad. Voor mij als baasje erg leuk om foto's te krijgen, te weten dat het goed gaat. Pippaya Hondenopvang is zeker een aanrader. Dikke 10!`,
    date: "2025-05-30",
  },
];

// Helper function to get total number of reviews
export const getTotalReviews = (): number => {
  return reviews.length;
};

// Helper function to get recent reviews (last 3 months)
export const getRecentReviews = (): Review[] => {
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

  return reviews.filter((review) => {
    if (!review.date) return true;
    return new Date(review.date) >= threeMonthsAgo;
  });
};
